// ─── Colors ───────────────────────────────────────────────────────────────────

export const TEAL = "#008080";

// ─── Drawer config ────────────────────────────────────────────────────────────

export const DRAWER_TITLE = "View / Upload Source Files";
export const DRAWER_WIDTH = "45vw";
export const DRAWER_PLACEMENT = "right";
export const DRAWER_ROOT_CLASS = "sb-source-files-drawer";

// ─── Files table ──────────────────────────────────────────────────────────────

export const FILES_SCROLL_THRESHOLD = 5;
export const FILES_SCROLL_Y = 320;

// ─── Upload section ───────────────────────────────────────────────────────────

export const UPLOAD_SECTION_TITLE = "Upload files";

export const ACCEPTED_FILE_FORMATS = ".pdf,.docx,.jpeg,.png,.mp4,.mov";

export const UPLOAD_DESCRIPTION =
  "Add your documents here. HR may periodically review your files, and hiring managers will review them if you apply for a role. Ensure your files are accurate and approved by your organization to avoid disciplinary action. Skills will be re-inferred each time you click Save.";

// ─── Dragger ──────────────────────────────────────────────────────────────────

export const DRAGGER_SCANNING_TEXT = "Scanning file...";
export const DRAGGER_TEXT = "Drop or Upload a file, image or video.";
export const DRAGGER_HINT =
  "Accepted Formats: .docx, .pdf, .jpeg, .png, .mp4 and .mov, up to 10MB accepted.";

// ─── Button labels ────────────────────────────────────────────────────────────

export const SAVE_BUTTON_LABEL = "Save and Infer";
export const SUBMIT_BUTTON_LABEL = "Agree & Submit";

// ─── Button tooltips ──────────────────────────────────────────────────────────

export const SAVE_BUTTON_TITLE =
  'Click "Save" to have Skills Bridger re-infer your skills using all files. You can delete uploaded files until you click "Agree & Submit".';

export const SUBMIT_BUTTON_TITLE =
  'Click "Agree & Submit" after making all changes. After submission, you cannot delete any files.';

// ─── In-drawer tour ───────────────────────────────────────────────────────────

// Element ids the tour spotlights; also set as the buttons' `id` so the targets
// and the buttons stay in sync.
export const SAVE_BUTTON_ID = "sb-tour-save-infer";
export const SUBMIT_BUTTON_ID = "sb-tour-submit";

// Step data (text/config only). The drawer maps these into AntD Tour steps and
// renders the <TourStep> content — JSX stays in the view layer.
export const DRAWER_TOUR_STEPS = [
  {
    targetId: SAVE_BUTTON_ID,
    placement: "left",
    title: "Save and Infer",
    description:
      "Once your files are added, click Save and Infer. Skills Bridger re-reads your documents and updates your skills.",
  },
  {
    targetId: SUBMIT_BUTTON_ID,
    placement: "left",
    // Last step continues into the main tour, so label it "Next", not "Finish".
    nextButtonText: "Next",
    title: "Agree & Submit",
    description:
      "Review the results, then click Agree & Submit. This updates your skill profile on our system.",
  },
];
